export const FICHA_LOADING = 'FICHA_LOADING';
export const FICHA_LOADED = 'FICHA_LOADED';
export const FICHA_ERROR = 'FICHA_ERROR';

export const FICHAINDI_LOADING = 'FICHAINDI_LOADING';
export const FICHAINDI_LOADED = 'FICHAINDI_LOADED';
export const FICHAINDI_ERROR = 'FICHAINDI_ERROR';
export const SET_CURRENT_FICHA_ID = 'SET_CURRENT_FICHA_ID';

export const FICHAINDIEDITAR_LOADING = 'FICHAINDIEDITAR_LOADING';
export const FICHAINDIEDITAR_LOADED = 'FICHAINDIEDITAR_LOADED';
export const FICHAINDIEDITAR_ERROR = 'FICHAINDIEDITAR_ERROR';

export const CREARFICHA_ERROR = 'CREARFICHA_ERROR';
export const CREARFICHA_LOADED = 'CREARFICHA_LOADED';
export const CREARFICHA_LOADING = 'CREARFICHA_LOADING';

export const EDITARFICHA_ERROR = 'EDITARFICHA_ERROR';
export const EDITARFICHA_LOADED = 'EDITARFICHA_LOADED';
export const EDITARFICHA_LOADING = 'EDITARFICHA_LOADING';

export const DELETEFICHA_ERROR = 'DELETEFICHA_ERROR';
export const DELETEFICHA_LOADED = 'DELETEFICHA_LOADED';
export const DELETEFICHA_LOADING = 'DELETEFICHA_LOADING';

export const COLABORADOR_FICHA_ERROR = 'COLABORADOR_FICHA_ERROR';
export const COLABORADOR_FICHA_LOADED = 'COLABORADOR_FICHA_LOADED';
export const COLABORADOR_FICHA_LOADING = 'COLABORADOR_FICHA_LOADING';

export const SIMILITUD_FICHA_ERROR = 'SIMILITUD_FICHA_ERROR';
export const SIMILITUD_FICHA_LOADED = 'SIMILITUD_FICHA_LOADED';
export const SIMILITUD_FICHA_LOADING = 'SIMILITUD_FICHA_LOADING';

export const CREAR_VERSION_FICHA_ERROR = 'CREAR_VERSION_FICHA_ERROR';
export const CREAR_VERSION_FICHA_LOADED = 'CREAR_VERSION_FICHA_LOADED';
export const CREAR_VERSION_FICHA_LOADING = 'CREAR_VERSION_FICHA_LOADING';

export const VERSION_FICHA_ERROR = 'VERSION_FICHA_ERROR';
export const VERSION_FICHA_LOADED = 'VERSION_FICHA_LOADED';
export const VERSION_FICHA_LOADING = 'VERSION_FICHA_LOADING';

export const VER_FICHA_ERROR = 'VER_FICHA_ERROR';
export const VER_FICHA_LOADED = 'VER_FICHA_LOADED';
export const VER_FICHA_LOADING = 'VER_FICHA_LOADING';

 


